import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {
  private readonly consentKey = 'cookieConsent';

  constructor() {
  }

  hasConsent(): boolean {
    return localStorage.getItem(this.consentKey) === 'true';
  }

  setConsent(): void {
    localStorage.setItem(this.consentKey, 'true');
  }
}
